"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pickupHighContrastHues = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("../../../utils");
var array_1 = require("../../array");
var tuple_1 = require("../../functions/tuple");
var hsl_to_rgb_1 = require("./basic-conversion/hsl-to-rgb");
var relative_luminance_1 = require("./contrast/relative-luminance");
// constants
var hues = (0, array_1.seq)(360).map(function (i) { return i; });
/**
 * relativeLuminanceの差分を累積した分布関数を縦軸yでn等分して、対応するx座標（＝hue）を返す
 */
var pickupHighContrastHues = function (n, saturation, lightness) {
    var e_1, _a;
    var _b;
    var luminanceList = hues.map(function (hue) {
        return (0, relative_luminance_1.relativeLuminance)((0, hsl_to_rgb_1.hslToRgb)([hue, saturation, lightness]));
    });
    var luminanceDiffAccumulated = (function () {
        var _a;
        var firstValue = (_a = array_1.array.first(luminanceList)) !== null && _a !== void 0 ? _a : 0;
        var rest = array_1.array.rest(luminanceList);
        return (0, utils_1.IList)((0, array_1.scan)(rest, function (_a, curr) {
            var _b = tslib_1.__read(_a, 2), prev = _b[0], acc = _b[1];
            return (0, tuple_1.t)(curr, acc + Math.abs(curr - prev));
        }, (0, tuple_1.t)(firstValue, 0)).map(function (_a) {
            var _b = tslib_1.__read(_a, 2), _ = _b[0], acc = _b[1];
            return acc;
        }));
    })();
    var maxValue = (_b = luminanceDiffAccumulated.max()) !== null && _b !== void 0 ? _b : 1;
    /* pickup n hues */
    var result = new Array();
    var i = 0;
    var y = maxValue * (i / n);
    try {
        for (var _c = tslib_1.__values(luminanceDiffAccumulated.entries()), _d = _c.next(); !_d.done; _d = _c.next()) {
            var _e = tslib_1.__read(_d.value, 2), x = _e[0], value = _e[1];
            if (value > y) {
                result.push(x);
                i += 1;
                y = maxValue * (i / n);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return (0, utils_1.IList)(result);
};
exports.pickupHighContrastHues = pickupHighContrastHues;
